import React, { useState } from 'react';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import IconButton from '@mui/material/IconButton';
import { useFullScreen } from 'contexts/FullScreenContext';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { SxProps, useTheme } from '@mui/material';

type Props = {
    disabled?: boolean;
    iconSx?: SxProps;
    // Facultative callback to be called when the fullscreen mode is toggled
    onClick?: (e: React.MouseEvent, fullscreenValue?: boolean) => void;
};

const ConditionnalZoomIconButton = ({
    onClick = undefined,
    disabled = false,
    iconSx = undefined,
}: Props) => {
    const { t } = useTranslation();
    const { isFullScreen, toggleIsFullScreen } = useFullScreen();
    const theme = useTheme();
    /**
     * this state is mandatory so tooltip closes when toggleIsFullScreen is called
     * open, onOpen and onClose props should be defined as well
     */
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        // if there is a callback, call it with new fullscreen value
        if (onClick) onClick(e, !isFullScreen);
        setIsTooltipOpen(false);
        toggleIsFullScreen();
    };

    const ZoomIcon = isFullScreen ? ZoomInMapIcon : ZoomOutMapIcon;
    const title = isFullScreen
        ? t('common.fullScreen.zoomIn')
        : t('common.fullScreen.zoomOut');
    return (
        <Tooltip
            title={title}
            open={isTooltipOpen}
            onOpen={() => setIsTooltipOpen(true)}
            onClose={() => setIsTooltipOpen(false)}
        >
            <IconButton onClick={handleClick} disabled={disabled} sx={iconSx}>
                <ZoomIcon
                    fontSize="medium"
                    sx={{
                        opacity: disabled ? 0.5 : 1,
                        color: theme.palette.primary.main,
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};

export default ConditionnalZoomIconButton;
